export default {
  health: {icon: 'ActivityIcon'},
  play: {icon: 'UsersIcon'},
  spirituality: {icon: 'SunriseIcon'},
  enviroment: {icon: 'ImageIcon'},
  work: {icon: 'BriefcaseIcon'},
  wealth: {icon: 'DollarSignIcon'},
  growth: {icon: 'BookIcon'},
  relationships: {icon: 'HeartIcon'},
}
